<template>
  <div>
    <v-select
      outlined
      v-model="dish"
      :items="state.dishes"
      item-text="name"
      item-value="name"
      :menu-props="{ maxHeight: '400', zIndex: 13 }"
      label="Plat"
    ></v-select>
  </div>
</template>

<script>
import {
  computed,
  onMounted,
  reactive,
  set,
  watch,
} from "@vue/composition-api";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

import { URL_PARAM_NAMES } from "@/utils/constants";

const COMPONENT_NAME = "DishFilter";

export default {
  name: COMPONENT_NAME,
  setup(props, { emit }) {
    const { store } = useProxy();
    const { axiosGet } = useAxios();

    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    const state = reactive({
      dishes: [],
    });

    // =>  METHODS

    // =>  COMPUTED
    const dish = computed({
      get: () => store.getters["marmiton/getDish"],
      set(e) {
        store.dispatch("marmiton/updateDish", e);
      },
    });

    // =>  WATCH
    watch(dish, (newValue) => {
      addQueryStringParam({
        param: URL_PARAM_NAMES[COMPONENT_NAME],
        value: newValue,
        // is_multiple: false,
        // is_integer: false,
        // is_boolean: false,
      });
    });

    // =>  HOOKS
    onMounted(async () => {
      const { data } = await axiosGet("/regie/marmiton/dish-types");
      set(state, "dishes", data);

      await synchronizeFilterWithQueryString({
        dispatcher: "marmiton/updateDish",
        param: URL_PARAM_NAMES[COMPONENT_NAME],
        value: dish.value,
        // is_multiple: false,
        // is_integer: false,
        // is_boolean: false,
        // dependsOn: undefined,
      });
    });

    // =>  DATA
    return {
      state,
      dish,
    };
  },
};
</script>

<style></style>
